import { useFeatureFlags } from '@usap/core';

const usePushNotificationOptIn = () => {
  const { f44 } = useFeatureFlags();

  const f44Enabled = ['b', '1', 'on', 'true'];

  if (typeof f44 === 'string') {
    if (f44Enabled.includes(f44)) {
      return true;
    }
    return false;
  }

  return false;
};

export default usePushNotificationOptIn;
